import { Helmet } from 'react-helmet-async';

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
}) => {
  const siteTitle = 'SitSmart - Smart Seating For Every Home';
  const fullTitle = title ? `${title} | SitSmart` : siteTitle;
  const defaultDesc = 'Pakistan\'s premium furniture brand. Durable plastic furniture, baby chairs, office chairs. Smart seating for every home.';
  const metaDesc = description || defaultDesc;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      {image && <meta name="twitter:image" content={image} />}
      <link rel="canonical" href={url || window.location.href} />
    </Helmet>
  );
};

export default SEO;
